import { h } from 'preact';

const handleClick = async (event) => {
  const gender = event.currentTarget.getAttribute('data-gender');
  const neck = event.currentTarget.getAttribute('data-neck');
  const sleeve = event.currentTarget.getAttribute('data-sleeve');

  const gan = localStorage.getItem('gan') || '';
  const hideKids = localStorage.getItem('isKidsGraphic') !== 'true';
  const hideHoodedFleece = localStorage.getItem('isHoodieGraphic') !== 'true';
  const hideTank = localStorage.getItem('isTankGraphic') !== 'true';
  const customizerBackgroundImgUrl = localStorage.getItem('customizerBackgroundImgUrl' || '');
  const customizerShippingDelayMessage = localStorage.getItem('customizer_shipping_delay_message' || '');

  // Store the necessary data in local storage
  localStorage.setItem(
    'spectrumLoadProduct',
    JSON.stringify({
      hideHoodedFleece,
      hideTank,
      hideKids,
      shippingMessage: customizerShippingDelayMessage ? JSON.parse(customizerShippingDelayMessage)?.string : 'Made to Order: Item(s) will ship from our U.S. factory within 5-6 business days.',
      gan,
      backgroundImgUrl:
        customizerBackgroundImgUrl || 'https://images.lifeisgood.com/custom_products_beach_background.png',
      options: { gender, neck, sleeve },
    }),
  );

  // Redirect to the customizer page
  window.location.href = '/pages/customizer';
};

const StyleCard = ({ style }) => (
  <div
    key={style.id}
    className="cursor-pointer p-4 hover:underline"
    data-sleeve={style.sleeve}
    data-gender={style.gender}
    data-neck={style.neck}
    onClick={handleClick}
  >
    <div className="bg-[#f9f8f8]">
      <img
        src={style.image}
        alt={`${style.name} silhouette`}
        className="m-auto block max-h-[164px]"
      />
    </div>
    <div className="mt-8 text-balance text-center font-gelo uppercase">{style.name}</div>
  </div>
);

export default StyleCard;
